(function () {
  if (customElements.get('zaoud-shop-the-look')) return;

  class ZaoudShopTheLook extends HTMLElement {
    connectedCallback() {
      if (this.dataset.zaoudStlInit === 'true') return;
      this.dataset.zaoudStlInit = 'true';

      this.pins = Array.from(this.querySelectorAll('[data-zaoud-stl-pin]'));
      this.panels = Array.from(this.querySelectorAll('[data-zaoud-stl-panel]'));
      this.railButtons = Array.from(this.querySelectorAll('[data-zaoud-stl-rail-btn]'));

      this.onActivate = this.onActivate.bind(this);
      this.pins.forEach((pin) => pin.addEventListener('click', this.onActivate));
      this.railButtons.forEach((btn) => btn.addEventListener('click', this.onActivate));

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.pins.forEach((pin) => pin.removeEventListener('click', this.onActivate));
      this.railButtons.forEach((btn) => btn.removeEventListener('click', this.onActivate));
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onBlockSelect = (event) => {
      if (!this.contains(event.target)) return;
      const pin = event.target.closest('[data-zaoud-stl-pin]');
      const id = pin && pin.dataset.productId;
      if (id) this.activate(id, { scrollRail: true });
    };

    onActivate(event) {
      const trigger = event.currentTarget;
      const id = trigger && trigger.dataset.productId;
      if (!id) return;
      this.activate(id, { scrollRail: true });
    }

    activate(id, options) {
      const opts = options || {};

      this.pins.forEach((pin) => {
        const active = pin.dataset.productId === id;
        pin.classList.toggle('is-active', active);
        pin.setAttribute('aria-expanded', active ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const active = panel.dataset.productId === id;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      this.railButtons.forEach((btn) => {
        const active = btn.dataset.productId === id;
        btn.classList.toggle('is-active', active);
        if (active && opts.scrollRail) {
          btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }
  }

  customElements.define('zaoud-shop-the-look', ZaoudShopTheLook);
})();
